import React from 'react';

function ProfileCard({ profile, isActive, onClick }) {
  const { icon, label, description, estimatedSize, estimatedTime, useCase, quality, maxWidth, maxHeight } = profile;

  return (
    <div 
      className={`profile-card ${isActive ? 'active' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
      aria-pressed={isActive}
    >
      {isActive && <div className="profile-card-check">✓</div>}
      
      <div className="profile-card-header">
        <div className="profile-card-title">
          <span className="profile-card-icon">{icon}</span>
          <span>{label}</span>
        </div>
        {profile.isDefault && (
          <span className="profile-card-badge">Default</span>
        )}
      </div>

      <div className="profile-card-details">
        <div className="profile-card-detail">
          <span className="profile-card-label">Resolution</span>
          <span className="profile-card-value">{maxWidth} × {maxHeight}</span>
        </div>
        <div className="profile-card-detail">
          <span className="profile-card-label">File Size</span>
          <span className="profile-card-value">{estimatedSize}</span>
        </div>
        <div className="profile-card-detail">
          <span className="profile-card-label">Upload Time</span>
          <span className="profile-card-value">{estimatedTime}</span>
        </div>
      </div>

      {/* Quality bar */}
      <div className="quality-bar">
        <div 
          className="quality-bar-fill" 
          style={{ width: `${quality * 100}%` }}
          title={`${Math.round(quality * 100)}% quality`}
        />
      </div>

      <p className="profile-card-description">{description}</p>
      <p className="profile-card-use-case">{useCase}</p>
    </div>
  );
}

export default ProfileCard;

